import { FC } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import './App.css';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import { Home } from './components/Home/Home';
import logo from './assets/images/logo_lis_positivo.svg';
import { Launches } from './components/Launches/Launches';
import { Errors } from './components/Errors/Errors';
import { Scenario } from './components/Scenario/Scenario';
import { ScenarioPlan } from './components/ScenarioPlan/ScenarioPlan';
import { Admin } from './components/Admin/Admin';
import { AppLayout } from './components/AppLayout/AppLayout';
import { ScenarioRecovery } from './components/ScenarioRecovery/ScenarioRecovery';
import { OperativeScenario } from './components/OperativeScenario/OperativeScenario';
import { ADMIN_PERMISSIONS } from './data/constants';

export const App: FC = (): JSX.Element => {
  const history: any = useHistory();

  return (
    <>
      <ToastContainer autoClose={1500} />
      <Router history={history} />
    </>
  );
};

const Router: FC<any> = ({ history }): JSX.Element => {
  return (
    <Switch>
      <Route exact path={"/"}>
        <Redirect to="/home" />
      </Route>

      <Route exact path={"/home"}>
        <AppLayout
          title="Menú Principal"
          history={history}
          image={logo}
          Component={Home}
          groupPermission={ADMIN_PERMISSIONS}
          canAccess={true}
        />
      </Route>

      <Route exact path={"/home/:id"}>
        <AppLayout
          title="Administración de escenarios"
          history={history}
          image={logo}
          Component={ScenarioRecovery}
          groupPermission={ADMIN_PERMISSIONS}
          canAccess={true}
        />
      </Route>

      <Route exact path={"/scenario_view/:id/:id_compare"}>
        <AppLayout
          title="Visualización del escenario"
          history={history}
          image={logo}
          Component={Scenario}
          groupPermission={ADMIN_PERMISSIONS}
          canAccess={true}
        />
      </Route>

      <Route exact path={"/scenario_plan/:id/:id_compare"}>
        <AppLayout
          title="Visualización de la simulación"
          history={history}
          image={logo}
          Component={ScenarioPlan}
          groupPermission={ADMIN_PERMISSIONS}
          canAccess={true}
        />
      </Route>

      <Route exact path={"/operative_scenario/:id"}>
        <AppLayout
          title="Visualización del escenario"
          history={history}
          image={logo}
          Component={OperativeScenario}
          groupPermission={ADMIN_PERMISSIONS}
          canAccess={true}
        />
      </Route>

      <Route exact path={"/launches"}>
        <AppLayout
          title="Lanzamientos"
          history={history}
          image={logo}
          Component={Launches}
          groupPermission={ADMIN_PERMISSIONS}
          canAccess={true}
        />
      </Route>

      <Route exact path={"/errors"}>
        <AppLayout
          title="Errores Comunes"
          history={history}
          image={logo}
          Component={Errors}
          groupPermission={ADMIN_PERMISSIONS}
          canAccess={true}
        />
      </Route>

      <Route exact path={"/admin"}>
        <AppLayout
          title="Administración"
          history={history}
          image={logo}
          Component={Admin}
          groupPermission={ADMIN_PERMISSIONS}
          canAccess={true}
        />
      </Route>

      <Redirect to={"/home"} />
    </Switch>
  );
};
